import Monitor from "./components/Monitor";
import Admin from "./components/Admin";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Monitor />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
